import React from 'react'
import classNames from 'classnames'
import { motion, AnimatePresence } from 'framer-motion'
import PropTypes from 'prop-types'
import { PANEL_TRANSITION_TYPES, PANEL_LAYOUT_TYPES } from '@helpers/constants'
import {
    PanelStyle,
    OverHeaderPanelStyle,
    TransitionTypeStyle,
    LayoutTypeStyle,
    ShadowStyle,
    PanelHeightMinusHeader,
} from './style'

const Panel = (props) => {
    const {
        children,
        visible,
        transitionType,
        layoutType = PANEL_LAYOUT_TYPES.PANEL,
        width = '100%',
        styles = {},
        overHeader = false,
        shadow = false,
        zIndex = 40,
    } = props

    const getInitial = () => {
        switch (transitionType) {
            case PANEL_TRANSITION_TYPES.FROM_LEFT:
                return { x: '-100%' }
            case PANEL_TRANSITION_TYPES.FROM_RIGHT:
                return { x: '100%' }
            case PANEL_TRANSITION_TYPES.FROM_BOTTOM:
                return { y: '100%' }
            case PANEL_TRANSITION_TYPES.FADE:
                return { opacity: 0 }
            default:
                // From left if none specified
                return { x: '-100%' }
        }
    }

    const getAnimate = () => {
        switch (transitionType) {
            case PANEL_TRANSITION_TYPES.FROM_RIGHT:
            case PANEL_TRANSITION_TYPES.FROM_LEFT:
                return { x: 0 }
            case PANEL_TRANSITION_TYPES.FROM_BOTTOM:
                return { y: 0 }
            case PANEL_TRANSITION_TYPES.FADE:
                return { opacity: 1 }
            default:
                // Sideways if none specified
                return { x: 0 }
        }
    }

    const getExit = () => {
        switch (transitionType) {
            case PANEL_TRANSITION_TYPES.FROM_LEFT:
                return { x: '-100%' }
            case PANEL_TRANSITION_TYPES.FROM_RIGHT:
                return { x: '100%' }
            case PANEL_TRANSITION_TYPES.FROM_BOTTOM:
                return { y: '100%' }
            case PANEL_TRANSITION_TYPES.FADE:
                return { opacity: 0 }
            default:
                // From left if none specified
                return { x: '-100%' }
        }
    }

    const className = classNames(
        layoutType !== PANEL_LAYOUT_TYPES.MODAL ? OverHeaderPanelStyle : PanelStyle,
        TransitionTypeStyle[transitionType],
        LayoutTypeStyle[layoutType],
        shadow ? ShadowStyle : '',
        zIndex ? 'z-' + zIndex : 'z-40'
    )

    const customStyle = {
        width: width,
        ...styles,
    }

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    className={className}
                    style={customStyle}
                    initial={getInitial()}
                    animate={{
                        ...getAnimate(),
                        transition: {
                            ease: 'easeInOut',
                            duration: 0.35,
                        },
                    }}
                    exit={{
                        ...getExit(),
                        transition: {
                            ease: 'easeInOut',
                            duration: 0.25,
                        },
                    }}
                >
                    {children}
                </motion.div>
            )}
        </AnimatePresence>
    )
}

Panel.propTypes = {
    children: PropTypes.node.isRequired,
    visible: PropTypes.bool,
    transitionType: PropTypes.string,
    width: PropTypes.string,
    overHeader: PropTypes.bool,
    zIndex: PropTypes.number,
}

export default Panel
